import L from "leaflet";
import {
  MapContainer,
  TileLayer,
  Marker,
  Polyline,
  useMapEvents,
} from "react-leaflet";

import "leaflet/dist/leaflet.css";

const redIcon = new L.Icon({
  iconUrl: process.env.PUBLIC_URL + "/images/marker-icon-red.png",
  shadowUrl:process.env.PUBLIC_URL + "/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const greenIcon = new L.Icon({
    iconUrl: process.env.PUBLIC_URL + "/images/marker-icon-green.png",
  shadowUrl:process.env.PUBLIC_URL + "/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

function ClickMarker({ position, setPosition, disabled }) {
  useMapEvents({
    click(e) {
      if (!disabled) {
        setPosition(e.latlng);
      }
    },
  });

  return null;
}

export default function ScotlandMap({
  position,
  setPosition,
  actual,
}) {
  const bounds = [
    [54.5, -8.5],
    [60.9, -0.5],
  ];

  return (
    <MapContainer
      bounds={bounds}
      maxBounds={bounds}
      maxBoundsViscosity={1}
      className="h-full w-full"
    >
      <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />

      <ClickMarker
        position={position}
        setPosition={setPosition}
        disabled={!!actual}
      />

      {/* Player Guess */}
      {position && (
        <Marker
          position={[position.lat, position.lng]}
          icon={redIcon}
        />
      )}

      {/* Actual Location */}
      {actual && (
        <Marker
          position={[actual.lat, actual.lng]}
          icon={greenIcon}
        />
      )}

      {/* Line Between Guess and Answer */}
      {position && actual && (
        <Polyline
          positions={[
            [position.lat, position.lng],
            [actual.lat, actual.lng],
          ]}
          pathOptions={{
            color: "blue",
            weight: 4,
          }}
        />
      )}
    </MapContainer>
  );
}